import type { Entry, Team } from "./types";

export const ROUND_BONUS = [0, 0, 5, 10, 15, 20, 25] as const;

export function teamPoints(t: Team): number {
  return t.wins * 3 + t.draws + t.goals_for + t.clean_sheets * 2 + ROUND_BONUS[t.round_reached];
}

export interface PointsPart {
  count: number;   // raw tally (wins, goals, …); 0 for the round bonus
  points: number;  // points that part contributes
}

export interface TeamPointsBreakdown {
  wins: PointsPart;
  draws: PointsPart;
  goals: PointsPart;
  cleanSheets: PointsPart;
  roundBonus: PointsPart;
  total: number;
}

// Decompose a team's points into its scoring components. The component points
// always sum to `total` (== teamPoints), so the UI can show the maths add up.
export function teamPointsBreakdown(t: Team): TeamPointsBreakdown {
  return {
    wins: { count: t.wins, points: t.wins * 3 },
    draws: { count: t.draws, points: t.draws },
    goals: { count: t.goals_for, points: t.goals_for },
    cleanSheets: { count: t.clean_sheets, points: t.clean_sheets * 2 },
    roundBonus: { count: 0, points: ROUND_BONUS[t.round_reached] },
    total: teamPoints(t),
  };
}

export function teamCards(t: Team): number {
  return t.yellows + t.reds * 2;
}

export function entryScores(e: Entry, teams: Record<string, Team>) {
  const p1 = teams[e.pot1_team];
  const p2 = teams[e.pot2_team];
  const p3 = teams[e.pot3_team];
  return {
    mainPoints: teamPoints(p1) + teamPoints(p2) + teamPoints(p3) * 2,
    cardsTotal: teamCards(p1) + teamCards(p2) + teamCards(p3),
    yellows: p1.yellows + p2.yellows + p3.yellows,
    reds: p1.reds + p2.reds + p3.reds,
    goalsConceded: p1.goals_against + p2.goals_against + p3.goals_against,
    tiebreakerRound: p3.round_reached,
  };
}
